import { render, staticRenderFns } from "./nutrition.vue?vue&type=template&id=df42856e&scoped=true&"
import script from "./nutrition.vue?vue&type=script&lang=js&"
export * from "./nutrition.vue?vue&type=script&lang=js&"
import style0 from "./nutrition.vue?vue&type=style&index=0&id=df42856e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df42856e",
  null
  
)

export default component.exports